import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faAws } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { faListCheck } from "@fortawesome/free-solid-svg-icons";

const labelsFirst = [
    "TypeScript",
    "JavaScript",
    "React (Next.js)",
    "React Native (Expo)",
    "Angular (Ionic)",
    "PHP (Yii framework)",
    "Nodejs (Express)",
    "HTML5",
    "CSS",
    "MySQL",
    "Figma",
    "Postman"
];

const labelsSecond = [
    "Git",
    "Linux",
    "AWS",
    "DigitalOcean",
    "Sentry",
];

const labelsThird = [
    "Pivotal Tracker",
    "Facilitation",
    "Team Collaboration",
    "Problem-Solving",
    "Communication",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Web and Mobile Development</h3>
                    <p>
                       I have built a diverse range of web and mobile applications from scratch using modern technologies such as React and Node.js. I have a strong proficiency in the SDLC process and frontend + backend development.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faAws} size="3x"/>
                    <h3>DevOps & Automation</h3>
                    <p>Once the application is built, I help clients set up DevOps testing, CI/CD pipelines, and deployment automation to support the successful Go-Live.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faListCheck} size="3x"/>
                    <h3>Scrum Enthusiast </h3>
                    <p>
                    I am passionate about Agile methodologies and Scrum practices. While I don’t have extensive professional experience in a formal project management role, I have successfully applied Scrum concepts in projects during my previous career. I enjoy collaborating with teams, defining goals, and prioritizing tasks to drive progress and deliver value.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;